export default __webpack_public_path__ + "static/media/P978MANA1.c27a7158.pdf";